import React, { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';

import DateFnsUtils from '@date-io/date-fns';
import {
  Box,
  Button,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from '@material-ui/core';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import deLocale from 'date-fns/locale/es';

import { finishInspection } from '../../../../../../../src/services/sinisterInspections/sinisterInspections.service';
import { ReactComponent as CalendarIcon } from '../../../../../../assets/img/calendar.svg';
import { ReactComponent as LocationIcon } from '../../../../../../assets/img/location.svg';
import { ReactComponent as TimeIcon } from '../../../../../../assets/img/reloj.svg';
import FloatingButton from '../../../../../../components/FloatingButton';
import { NumberFormatCustom } from '../../../../../../components/NumberFormartCustom/NumberFormatCustom.component';
import SharedDialog from '../../../../../../components/SharedDialog/SharedDialog.component';
import { useSinisterInspectionsContext } from '../../../../../../context/SinisterInspections/SinisterInspections.provider';
import { useAuthDataContext } from '../../../../../../context/auth/auth.provider';
import { useIncidentsContext } from '../../../../../../context/incidents/incidents.provider';
import useForm from '../../../../../../helpers/useForm';
import SummaryValidations from './Summary.validations';

const Summary = () => {
  const {
    goBack,
    sinister_inspection_body,
    updateSinisterInspectionBody,
    nextStep,
  } = useSinisterInspectionsContext();

  const { incident } = useIncidentsContext();
  const [dialog, setDialog] = React.useState(false);
  const [confirmError, setConfirmError] = React.useState(false);
  const history = useHistory();

  /* Datos del taller, Fecha y hora */
  const [selectedDate, setSelectedDate] = React.useState(new Date(Date.now()));
  const [userSelectedDate, setUserSelectedDate] = useState(
    sinister_inspection_body?.selectedDate
  );
  const [defaultValues, setDefaultValues] = useState({
    name: sinister_inspection_body?.name,
    email: sinister_inspection_body?.email,
    phone_number: sinister_inspection_body?.phone_number,
    selectedDate: sinister_inspection_body?.selectedDate,
    from: sinister_inspection_body?.from,
    to: sinister_inspection_body?.to,
    address:
      sinister_inspection_body?.pickup_location?.street +
      ' ' +
      sinister_inspection_body?.pickup_location?.street_number,
    betweenStreets: sinister_inspection_body?.betweenStreets,
    additionalInformation: sinister_inspection_body?.additionalInformation,
  });

  //console.log(sinister_inspection_body, "summary")

  /* Submit */
  const submitInspection = useMutation(
    () => {
      return finishInspection(incident.id, {
        inspection_type: 'custom_repair_shop_inspection',
        repair_shop_name: sinister_inspection_body?.name,
        repair_shop_phone: sinister_inspection_body?.phone_number,
        repair_shop_email: sinister_inspection_body?.email,
        street: sinister_inspection_body?.pickup_location?.street,
        street_number: sinister_inspection_body?.pickup_location?.street_number,
        street_extra: `entre las calles ${sinister_inspection_body?.betweenStreets}, ${sinister_inspection_body?.additionalInformation}`,
        province: sinister_inspection_body?.pickup_location?.province,
        city: sinister_inspection_body?.pickup_location?.locality,
        /* postal_code: sinister_inspection_body?.pickup_location?.description.split(', ')[1].toString().split(' ')[0], */
        meeting_date: sinister_inspection_body?.selectedDate /* '2022/04/12' */,
        meeting_time_from: sinister_inspection_body?.from,
        meeting_time_until: sinister_inspection_body?.to,
      }); // se necesitan => inspection_body, inspection_id
    },
    {
      onError: (err: any) => {
        setConfirmError(true);
      },
      onSuccess: (data: any) => {
        nextStep();
      },
    }
  );

  useEffect(() => {
    const availableDate = currentDate();
    setSelectedDate(availableDate);
  }, []);

  const handleDateChange = (date: any) => {
    if (date > new Date()) {
      setUserSelectedDate(date);
      updateSinisterInspectionBody({ selectedDate: date });
    } else {
      setUserSelectedDate(date);
      updateSinisterInspectionBody({ selectedDate: date });
    }
  };

  const minDate = () => {
    let date = new Date(Date.now());
    date.setDate(date.getDate() + 3);
    return date;
  };

  const maxDate = () => {
    let date = new Date(Date.now());
    date.setDate(date.getDate() + 30);
    return date;
  };

  const currentDate = () => {
    let date = new Date(Date.now());

    for (let i = 0; i < 4; i++) {
      if (date.getDay() === 6) {
        date.setDate(date.getDate() + 2);
        i--;
      } else {
        date.setDate(date.getDate() + 1);
      }
    }
    return date;
  };

  const disableWeekends = (date) => {
    const day = date.getDay();
    if (day === 6 || day === 0) {
      return true;
    }
  };

  const handlePlaceChange = () => {
    if (sinister_inspection_body.budgetPhotos === true) {
      goBack(4);
    } else {
      goBack(2);
    }
  };

  const handleSubmitData = async () => {
    await updateSinisterInspectionBody({
      ...values,
    });
    submitInspection.mutate();
  };

  const { embed } = useAuthDataContext();
  const redirectHome = () => {
    embed
      ? window.parent.postMessage({ return: 'overview' }, '*')
      : history.push('/dashboard');
  };

  /* useForm */
  const { values, errors, handleChange, handleSubmit } = useForm(
    handleSubmitData,
    SummaryValidations,
    defaultValues
  );

  return (
    <>
      <SharedDialog
        open={dialog}
        onClose={() => setDialog(false)}
        content={
          <Box>
            <Typography variant="h6">¡Atención!</Typography>
            <Box my={2}>
              <Typography>
                ¿Estás seguro que quieres cambiar al dirección?
              </Typography>
            </Box>
          </Box>
        }
        actions={
          <Grid container justify="flex-end">
            <Grid item xs={12} sm={6}>
              <Box mx={2} my={1}>
                <Button
                  variant="outlined"
                  color="secondary"
                  fullWidth
                  onClick={() => setDialog(false)}
                >
                  Cancelar
                </Button>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box mx={2} mb={2} mt={1} display="flex" alignItems="center">
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={handlePlaceChange}
                >
                  Entendido
                </Button>
              </Box>
            </Grid>
          </Grid>
        }
      ></SharedDialog>

      <SharedDialog
        open={confirmError}
        onClose={() => setConfirmError(false)}
        content={
          <Box>
            <Typography variant="h6">Ha ocurrido un error.</Typography>
            <Box mt={2}>
              <Typography>
                ¡Lo sentimos! La solicitud de inspección no puede procesarse en
                este momento. Te pedimos que reintentes en otro momento.
              </Typography>
            </Box>
          </Box>
        }
        actions={
          <Grid container justify="flex-end">
            <Grid item xs={12} sm={6}>
              <Box mx={2} my={1}>
                <Button
                  variant="outlined"
                  color="secondary"
                  fullWidth
                  onClick={() => setConfirmError(false)}
                >
                  Cancelar
                </Button>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box mx={2} mb={2} mt={1} display="flex" alignItems="center">
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={redirectHome}
                >
                  Entendido
                </Button>
              </Box>
            </Grid>
          </Grid>
        }
      ></SharedDialog>

      <Grid container justify="center">
        <Grid item xs={11}>
          <Box mt={4}>
            <Typography variant="h6">Datos del vehículo</Typography>
          </Box>

          <Box mb={1}>
            <Typography variant="subtitle2">Vehículo</Typography>
            <TextField
              value={`${
                incident?.item?.brand +
                ' ' +
                incident?.item?.model?.split(' ')[0]
              } - Patente ${incident?.item.license_plate}`}
              type="text"
              size="small"
              fullWidth={true}
              name="vehicle"
              id="vehicle"
              placeholder="Vehículo"
              variant="outlined"
              InputProps={{ readOnly: true }}
            />
          </Box>
        </Grid>

        <Grid item xs={11}>
          <Box mt={2}>
            <Typography variant="h6">Datos del taller</Typography>
          </Box>

          <Box mb={2}>
            <Typography variant="subtitle2">Nombre del taller</Typography>
            <TextField
              type="text"
              size="small"
              error={Boolean(errors['name'])}
              helperText={errors['name']}
              onChange={handleChange}
              fullWidth={true}
              name="name"
              id="name"
              placeholder="Ingresá nombre del taller"
              variant="outlined"
              value={values.name}
              defaultValue={sinister_inspection_body?.name || ''}
            />
          </Box>

          <Box mb={2}>
            <Typography variant="subtitle2">Email</Typography>
            <TextField
              type="email"
              size="small"
              error={Boolean(errors['email'])}
              helperText={errors['email']}
              onChange={handleChange}
              fullWidth={true}
              name="email"
              id="email"
              placeholder="Ingresá el email del taller"
              variant="outlined"
              value={values.email}
              defaultValue={sinister_inspection_body?.email || ''}
            />
          </Box>

          <Box mb={2} mt={2}>
            <Typography variant="subtitle2">Teléfono *</Typography>
            <TextField
              type="number"
              size="small"
              error={Boolean(errors['phone_number'])}
              helperText={errors['phone_number']}
              onChange={handleChange}
              fullWidth={true}
              name="phone_number"
              id="phone_number"
              placeholder="Ingresá el teléfono"
              variant="outlined"
              value={values.phone_number}
              defaultValue={sinister_inspection_body?.phone_number || ''}
              InputProps={{
                inputComponent: NumberFormatCustom as any,
              }}
            />
          </Box>
        </Grid>

        <Grid item xs={11}>
          <Box mt={2}>
            <Typography variant="h6">Datos del lugar</Typography>
          </Box>

          <Grid container justify="center">
            <Grid item xs={12}>
              <Grid container>
                <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
                  <Grid item xs={12} sm={5}>
                    <Box mb={2}>
                      <Typography
                        variant="subtitle2"
                        style={{ marginBottom: '-8px' }}
                      >
                        Fecha *
                      </Typography>
                      <KeyboardDatePicker
                        style={{ backgroundColor: 'white' }}
                        disableToolbar
                        variant="inline"
                        inputVariant="outlined"
                        format="dd/MM/yyyy"
                        margin="normal"
                        id="date-picker"
                        value={userSelectedDate}
                        onChange={handleDateChange}
                        minDate={minDate()}
                        maxDate={maxDate()}
                        KeyboardButtonProps={{ 'aria-label': 'change date' }}
                        keyboardIcon={<CalendarIcon />}
                        invalidLabel={'Formato de fecha inválido'}
                        invalidDateMessage={'Formato de fecha inválido'}
                        //InputProps={{ readOnly: true }}
                        fullWidth
                        shouldDisableDate={disableWeekends}
                        defaultValue={sinister_inspection_body?.selectedDate}
                      />
                    </Box>
                  </Grid>
                </MuiPickersUtilsProvider>
              </Grid>
            </Grid>
          </Grid>

          <Grid container justify="center">
            <Grid item xs={12}>
              <Grid container style={{ columnGap: '20px' }}>
                <Grid item xs={12} sm={5}>
                  <Box mb={2}>
                    <Typography
                      variant="subtitle2"
                      style={{ marginBottom: '8px' }}
                    >
                      De
                    </Typography>
                    <TextField
                      type="text"
                      size="small"
                      onChange={handleChange}
                      fullWidth={true}
                      name="from"
                      id="from"
                      variant="outlined"
                      value={values.from}
                      defaultValue={sinister_inspection_body?.from}
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <TimeIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={5}>
                  <Box mb={2}>
                    <Typography
                      variant="subtitle2"
                      style={{ marginBottom: '8px' }}
                    >
                      A
                    </Typography>
                    <TextField
                      type="text"
                      size="small"
                      onChange={handleChange}
                      fullWidth={true}
                      name="to"
                      id="to"
                      variant="outlined"
                      value={values.to}
                      defaultValue={sinister_inspection_body?.to}
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <TimeIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Box mb={2} onClick={() => setDialog(true)}>
              <Typography variant="subtitle2">Lugar</Typography>
              <TextField
                type="text"
                size="small"
                //error={Boolean(errors['address'])}
                //helperText={errors['address']}
                //onChange={handleChange}
                fullWidth={true}
                name="address"
                id="address"
                placeholder="Ingresá la dirección"
                variant="outlined"
                value={values.address}
                defaultValue={
                  sinister_inspection_body?.pickup_location?.street +
                  ' ' +
                  sinister_inspection_body?.pickup_location?.street_number
                }
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      <LocationIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box mb={2}>
              <Typography variant="subtitle2">Entre calles</Typography>
              <TextField
                type="text"
                size="small"
                //error={Boolean(errors['betweenStreets'])}
                //helperText={errors['betweenStreets']}
                onChange={handleChange}
                fullWidth={true}
                name="betweenStreets"
                id="betweenStreets"
                placeholder="Ingresá las calles"
                variant="outlined"
                value={values.betweenStreets}
                defaultValue={sinister_inspection_body?.betweenStreets || ''}
              />
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box mb={2}>
              <Typography variant="subtitle2">Información adicional</Typography>
              <TextField
                id="additionalInformation"
                name="additionalInformation"
                multiline
                fullWidth
                size="medium"
                rows={8}
                placeholder="Ingresá tus comentarios"
                variant="outlined"
                value={values.additionalInformation}
                onChange={handleChange}
                /* error={additionalInformation?.length > 1333} */
                /* helperText={
    additionalInformation?.length > 1333 &&
    'El relato del hecho no deberia superar los 1333 caracteres'
  } */
              />
            </Box>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Box my={4}>
            <FloatingButton onClick={handleSubmit}>
              Confirmar inspección
            </FloatingButton>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default Summary;
